import * as Sentry from "@sentry/react";
import { RouteObject, createBrowserRouter } from "react-router-dom";

import { AtiraRoute } from "../AtiraRoute";
import { AtiraRouteNotLoggedIn } from "../AtiraRouteNotLoggedIn";
import { Login } from "../loginSignup/Login";
import { Signup } from "../loginSignup/signup/Signup";
import { PrivateRouter } from "./Private.router";
import { ForgotPassword } from "../loginSignup/forgot-password/ForgotPassword";
import { InviteLandingPage } from "../permissions/invite/InvitesLandingPage";
import { GoogleCallback } from "../loginSignup/GoogleWindowCallback";
import { GoogleDriveWindowCallback } from "../integration/GoogleDriveWindowCallback";
import { FacebookMetaWindowCallback } from "../integration/FacebookMetaWindowCallback";
import { FACEBOOK_META_CALLBACK_PATH } from "../integration/utils/integration-utils";
import { Impersonate } from "../impersonate/Impersonate";

const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouterV6(createBrowserRouter);

const router = sentryCreateBrowserRouter([
  ...PrivateRouter,
  {
    path: "/login",
    element: <AtiraRouteNotLoggedIn component={<Login />} />,
  },
  {
    path: "/signup",
    element: <AtiraRouteNotLoggedIn component={<Signup />} />,
  },
  {
    path: "/forgot-password",
    element: <AtiraRouteNotLoggedIn component={<ForgotPassword />} />,
  },
  {
    path: "/permissions/invite",
    element: <InviteLandingPage />,
  },
  {
    path: "/callback",
    element: <GoogleCallback />,
  },
  {
    path: "/integration/google-drive/callback",
    element: <GoogleDriveWindowCallback />,
  },
  {
    path: FACEBOOK_META_CALLBACK_PATH,
    element: <FacebookMetaWindowCallback />,
  },
  {
    path: "/impersonate",
    element: <Impersonate />,
  },
  { path: "*", element: <AtiraRoute redirect="/" /> },
] as RouteObject[]);

export default router;
